import React from 'react';

interface SimpleBlogEntryGridProps {
    imageUrl?: string;
    imageAlt?: string;
    title: string;
    tags: string;
    date: string;
    description: string;
    authorName: string;
    authorPhoto?: string;
    linkTo?: string;
}

const PLACEHOLDER_IMAGE_PATTERN = /post-landscape-1\.jpg$/;

function SimpleBlogEntryGrid({
    imageUrl,
    imageAlt = '',
    title,
    tags,
    date,
    description,
    authorName,
    authorPhoto,
    linkTo = '#'
}: SimpleBlogEntryGridProps) {
    const isExternal = linkTo.startsWith('http://') || linkTo.startsWith('https://');
    const hasImage = !!imageUrl && !PLACEHOLDER_IMAGE_PATTERN.test(imageUrl);

    const LinkWrap = ({ children }: { children: React.ReactNode }) =>
        isExternal ? (
            <a href={linkTo} target="_blank" rel="noopener noreferrer">{children}</a>
        ) : (
            <a href={linkTo}>{children}</a>
        );

    const descText = description.length > 150 ? description.substring(0, 150).trim() + '…' : description;

    return (
        <article className="simple-blog-entry-grid__card">
            {hasImage && (
                <div className="simple-blog-entry-grid__image-wrap">
                    <LinkWrap>
                        <img src={imageUrl} alt={imageAlt || title} className="img-fluid" />
                    </LinkWrap>
                </div>
            )}
            <div className="simple-blog-entry-grid__body">
                <h3 className="simple-blog-entry-grid__title">
                    <LinkWrap>{title}</LinkWrap>
                </h3>
                <div className="simple-blog-entry-grid__meta">
                    <span className="simple-blog-entry-grid__tags">{tags}</span>
                    <span className="mx-1">•</span>
                    <span className="simple-blog-entry-grid__date">{date}</span>
                </div>
                <p className="simple-blog-entry-grid__description">{descText}</p>
                <div className="simple-blog-entry-grid__author">
                    {authorPhoto && (
                        <img
                            src={authorPhoto}
                            alt={authorName}
                            className="simple-blog-entry-grid__author-photo"
                            width={32}
                            height={32}
                        />
                    )}
                    <span className="simple-blog-entry-grid__author-name">{authorName}</span>
                </div>
            </div>
        </article>
    );
}

export default SimpleBlogEntryGrid;
